<template>
  <div>

    <div
      class="modal-dialog modal-small"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ data.title }}</h5>
        </div>
        <div class="modal-body">
          <section>
            <section-title
              :title="getSectionTitleName"
              fontweight="bold" />
            <div class="row">
              <div class="col-12">
                <input
                  :value="data.title"
                  type="text"
                  class="form-control"
                  disabled>
              </div>
            </div>
          </section>
          <section>
            <section-title
              :title="$t('message.getnotititle')"
              fontweight="bold" />
            <div class="row">
              <div
                v-for="(value, index) in code"
                :key="index"
                class="col-12 mt-2">
                <vs-checkbox
                  v-model="form.code"
                  :vsValue="value"
                  color="#A3CA76"
                  style="float: left;margin: 0;">
                  {{ $t('notificationcode.' + value) }}
                </vs-checkbox>
                <vs-tooltip
                  :text="$t('notificationcodedetail.' + value)"
                  position="top"
                  style="float: left;margin-left: 5px;">
                  <i class="fas fa-info-circle"/>
                </vs-tooltip>
              </div>
            </div>
          </section>
          <section>
            <section-title
              :title="$t('message.status')"
              fontweight="bold" />
            <div class="row">
              <div class="col-12">
                <select
                  v-model="form.active"
                  class="form-control custom-select">
                  <option :value="true">{{ $t('message.turnonnotification') }}</option>
                  <option :value="false">{{ $t('message.turoffnnotification') }}</option>
                </select>
              </div>
            </div>
          </section>
        </div>
        <div class="modal-footer">
          <button
            :disabled="$store.state.app.loading"
            type="button"
            class="btn btn-light"
            @click="cancel()">
            {{ $t('button.cancel') }}
          </button>
          <template>
            <button
              v-if="$store.state.app.loading"
              :disabled="true"
              type="button"
              class="btn btn-light">
              <i class="fas fa-spinner spin"/>
            </button>
            <button
              v-else
              type="button"
              class="btn btn-web"
              @click="update()">
              {{ $t('button.apply') }}
            </button>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    app_id: {
      type: Number,
    },
    code: {
      type: Array,
    },
    data: {
      type: Object,
    },
  },
  data () {
    return {
      form: {
        code: [],
        active: false,
      },
    }
  },
  computed: {
    getSectionTitleName () {
      switch (this.data.channel) {
        case 'email':
          return this.$t('message.email')
          break
        default:
          return this.$t('message.name')
      }
    },
  },
  created: function () {
    this.setForm()
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    async update () {
      let dataSet = {
        'ch_noti_id': this.data.ch_noti_id,
        'app_id': this.app_id,
        'code': this.form.code,
        'active': this.form.active,
      }

      let res = await this.$store.dispatch('updateChannelNoti', dataSet)

      this.$emit('done')
    },
    setForm () {
      this.form.code = this.data.code.filter(val => val >= (this.app_id * 100) && val <= ((this.app_id * 100) + 90))
      this.form.active = this.data.active_ids.find(val => val == this.app_id) !== undefined
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/modal/channelnoti/Edit.vue